<template> 
    <div class="whAll">
        <vue-ueditor-wrap v-model="msg" :config="myConfig" ></vue-ueditor-wrap>

        <!-- 预览 -->
        <div v-if="look" class="phone">
            <div  class="uditor1" v-html="msg" ></div> 
        </div> 
    </div>
    
</template> 
<script>
    import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
    export default {
        data () {
            return {  
                msg: '',
              
                myConfig: {
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 600,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                    serverUrl: 'https://api.jiapuji.vip/gateway/admin/service/ueditor/config',
                    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                    UEDITOR_HOME_URL: process.env.BASE_URL + 'UEditor/'
                }
            }
        },
        watch:{
            msg(val){
                this.$emit('txt',val);
            },
            look(val){
                
                if(!val){
                    this.msg = ''
                }else{
                    this.msg = this.msg1
                }
            }
        },
        props: ['look','msg1'],
        computed: {},
        components: {
            VueUeditorWrap
        },
        methods: {
           
        },
      
        mounted: function(){
            var that = this;

            

            // 当传输图片时、视频、涂鸦时改换请求地址
            setTimeout( () => {
                window.UE.Editor.prototype._bkGetActionUrl = window.UE.Editor.prototype.getActionUrl;
                window.UE.Editor.prototype.getActionUrl = function(action) {
                    if(action == 'uploadimage'){
                        return 'https://api.jiapuji.vip/gateway/admin/service/ueditor/upload/image';
                    }else if(action == 'uploadvideo') {
                        return 'https://api.jiapuji.vip/gateway/admin/service/ueditor/upload/video';
                    }else if(action == 'uploadscrawl'){
                        return 'https://api.jiapuji.vip/gateway/admin/service/ueditor/upload/scrawl';
                    }else{
                        return this._bkGetActionUrl.call(this, action);
                    }
                }
            },2000)
        }
    }
</script>  
<style scoped>
    
   
</style>
     